import AcfHelper from "../../_acf";
import Slider from "../../utils/_slider";
import Breakpoints from "../../utils/_breakpoints";

const slidersClass = `image-galleries-slider`;
const blockClass = `image-gallery-block`;

const ImageGallery = {};

ImageGallery.blockName = 'image-gallery';

ImageGallery.init = () => {
    AcfHelper.handleInit(ImageGallery.blockName, () => {
        Slider.init({
            slider: slidersClass,
            container: blockClass,
        }, {
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            autoplay: {
                delay: 1,
                disableOnInteraction: false,
            },
            duration: 1,
            freeMode: true,
            speed: 15000,
            spaceBetween: 18,
            breakpoints: {
                [Breakpoints.getValues().md]: {
                    slidesPerView: 2,
                    spaceBetween: 42,
                    speed: 20000,
                },
            },
        });
    });
};

ImageGallery.init();

export default ImageGallery;
